export default "__VITE_ASSET__46e0a6ec__"